import { render, staticRenderFns } from "./LaptopScore.vue?vue&type=template&id=5242cc54&"
import script from "./LaptopScore.vue?vue&type=script&lang=js&"
export * from "./LaptopScore.vue?vue&type=script&lang=js&"
import style0 from "./LaptopScore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports